import { mount } from 'svelte'
import RegistrationForm from '../components/auth/RegistrationForm.svelte'

const el = document.getElementById('registration-form-root')
if (el) {
  const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}

  mount(RegistrationForm, {
    target: el,
    props,
  })
}
